import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatOption, MatSelect } from '@angular/material/select';
import { environment } from '@environment/environment';
import { MaterialSymbol } from 'material-symbols';
import { NavigateToService } from '../../services/helper-services/navigate-to.service';
import { AppStateService } from '../app-state.service';
import { MenuComponent } from '../menu/menu.component';
import { SidebarHelpComponent } from './sidebar-help/sidebar-help.component';
import { SidebarStateService } from './sidebar-state.service';

@Component({
  selector: 'app-sidebar',
  imports: [
    MenuComponent,
    MatIcon,
    MatButtonModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatProgressSpinner,
    SidebarHelpComponent,
    MatDivider,
    MatChip,
    MatChipSet
  ],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {
  private readonly sidebarStateService = inject(SidebarStateService);
  private readonly appStateService = inject(AppStateService);
  private readonly navigateTo = inject(NavigateToService);

  readonly leftPanelCloseIcon: MaterialSymbol = 'left_panel_close';
  readonly leftPanelOpenIcon: MaterialSymbol = 'left_panel_open';

  $isSidebarExpanded = this.sidebarStateService.isExpanded;
  $isLoading = this.sidebarStateService.isLoading;
  $includeHelp = this.sidebarStateService.includeHelp;
  $availableElements = this.appStateService.availableElements;
  $selectedElement = this.appStateService.element;

  siteType = environment.siteType;

  toggleMenu(): void {
    this.sidebarStateService.toggleIsExpanded();
  }

  changeElement(elementId: number): void {
    const element = this.$availableElements().find(e => e.elementId === elementId);

    this.appStateService.setElement(element ?? null);
    if (!element) {
      this.navigateTo.landing();
    }
  }
}
